import styled from 'styled-components';
import { Popover } from '@sede-enterprise/shell-ds-react-framework';

export { NGContainer } from '../NominationGroups/style';

export const ActionMenu = styled(Popover)`
  z-index: 3;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 2px 5px,
    rgba(0, 0, 0, 0.2) 0 0 2px;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;

  .menu-container {
    display: flex;
    flex-direction: column;
    padding: 3px 5px;

    button {
      margin-top: 2px;
      font-weight: 400;
    }
  }
`;
